import { ReactNode } from 'react';
import logoImage from '../../assets/images/logo-dark.png';
import styles from './ErrorLayout.module.css';
import EnvironmentBanner from '../../components/ui/EnvironmentBanner/EnvironmentBanner';

interface IErrorLayout {
  children: ReactNode;
}

export const ErrorLayout = ({ children }: IErrorLayout) => {
  return (
    <>
      <a className="sr-only" href="#mainContent">
        Skip to main content
      </a>
      <EnvironmentBanner />
      <div className="d-flex" id="wrapper">
        <div id="mainContent" className={styles.errorWrapper}>
          <div className="container-fluid">
            <div className={styles.errorMessageContainer}>
              <div className={styles.logoContainer}>
                <img src={logoImage} alt="" />
              </div>
              <div>{children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
